module.exports = __webpack_public_path__ + "img/brandmark_gr-blk.26f8f7e.svg";